module.exports = __webpack_public_path__ + "img/empty-pitches.89a1e81a.svg";